import Select, { StylesConfig } from 'react-select'
import { Option } from '../../types'

type SingleSelectProps = {
  value: Option | null
  options: Array<Option>
  onChange: (value: Option) => void
  innerRef?: any
  [x: string]: any
}

const customStyles: StylesConfig = {
  menu: (provided) => ({
    ...provided,
    margin: 0,
    boxShadow: 'unset',
    borderLeft: 'solid 1px black',
    borderRight: 'solid 1px black',
    borderBottom: 'solid 1px black',
    borderTopLeftRadius: '0',
    borderTopRightRadius: '0',
    borderBottomLeftRadius: '4px',
    borderBottomRightRadius: '4px',
  }),

  control: (provided, state) => ({
    ...provided,
    borderRadius: '4px',
    borderColor: 'black',
    boxShadow: 'unset',
    height: '55px',
    '&:hover': {
      borderColor: 'black',
    },
    ...(state.menuIsOpen && {
      borderBottom: 'unset',
      borderBottomLeftRadius: '0',
      borderBottomRightRadius: '0',
    }),
  }),
  placeholder: (provided) => ({
    ...provided,
    marginLeft: 15,
  }),
  singleValue: (provided) => ({
    ...provided,
    padding: '0.75rem 0.8rem',
    fontWeight: '500',
  }),
  option: (provided, state) => {
    const isLastElement =
      // @ts-ignore
      state.label === state?.options?.[state?.options?.length - 1]?.label
    return {
      ...provided,
      padding: '15px 20px',
      fontWeight: '500',
      backgroundColor: [state.isSelected, state.isSelected].includes(true)
        ? 'black'
        : 'white',

      ...(isLastElement && {
        borderBottomLeftRadius: '4px',
        borderBottomRightRadius: '4px',
      }),
      ...(!state.isSelected && {
        '&:hover': {
          backgroundColor: 'rgba(20, 20, 20, 0.1)',
        },
      }),
      '&:active': {
        backgroundColor: 'black',
        color: 'white',
      },
    }
  },
}

function SingleSelect(props: SingleSelectProps) {
  const { value, onChange, options, innerRef, ...rest } = props
  return (
    <Select
      {...rest}
      ref={innerRef}
      instanceId="contact-select"
      options={options}
      isSearchable={false}
      className="mb-8 w-full font-inter"
      styles={customStyles}
      onChange={(e) => onChange(e as Option)}
      value={value}
    />
  )
}

export default SingleSelect
